// extracted by mini-css-extract-plugin
export default {"supportList":"index_supportList_Wq4wY","support":"index_support_MoMoR","name":"index_name_-gW-o","imgWp":"index_imgWp_kwL9l"};